"use strict";

var _interopRequireDefault = require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addDept = addDept;
exports.changeDept = changeDept;
exports.delDept = delDept;
exports.deptList = deptList;
exports.deptOptions = deptOptions;
exports.getDept = getDept;
exports.getUserDeptList = getUserDeptList;
exports.listChildrenDeptByRootId = listChildrenDeptByRootId;
exports.listDept = listDept;
exports.roleDeptTreeselect = roleDeptTreeselect;
exports.selectAllRootDeptTree = selectAllRootDeptTree;
exports.selectChildrenDeptByRootId = selectChildrenDeptByRootId;
exports.treeSelect = treeSelect;
exports.updateDept = updateDept;
exports.updateDeptCache = updateDeptCache;
var _request = _interopRequireDefault(require("@/utils/request"));
var _cloud = require("@/utils/cloud");
// 查询组织列表
function listDept(query) {
  return (0, _request.default)({
    url: _cloud.urls.user + '/system/dept/list',
    method: 'get',
    params: query
  });
}

// 查询组织详细
function getDept(deptId) {
  return (0, _request.default)({
    url: _cloud.urls.user + '/system/dept/' + deptId,
    method: 'get'
  });
}

// 查询组织下拉树结构
function treeSelect() {
  return (0, _request.default)({
    url: _cloud.urls.user + '/system/dept/treeSelect',
    method: 'get'
  });
}

// 根据角色ID查询组织树结构
function roleDeptTreeselect(roleId) {
  return (0, _request.default)({
    url: _cloud.urls.user + '/system/dept/roleDeptTreeselect/' + roleId,
    method: 'get'
  });
}

// 新增组织
function addDept(data) {
  return (0, _request.default)({
    url: _cloud.urls.user + '/system/dept',
    method: 'post',
    data: data
  });
}

// 修改组织
function updateDept(data) {
  return (0, _request.default)({
    url: _cloud.urls.user + '/system/dept',
    method: 'put',
    data: data
  });
}

// 删除组织
function delDept(deptId) {
  return (0, _request.default)({
    url: _cloud.urls.user + '/system/dept/' + deptId,
    method: 'delete'
  });
}

// 更新组织缓存
function updateDeptCache() {
  return (0, _request.default)({
    url: _cloud.urls.user + '/system/deptcache/updateDeptCache',
    method: 'get'
  });
}

// 获取部门列表
function deptOptions() {
  return (0, _request.default)({
    url: _cloud.urls.user + '/system/dept/deptOptions',
    method: 'get'
  });
}

// 获取部门列表
function deptList() {
  return (0, _request.default)({
    url: _cloud.urls.user + '/system/dept/deptList',
    method: 'get'
  });
}

// 获取部门列表
function changeDept(deptId) {
  return (0, _request.default)({
    url: _cloud.urls.user + '/changeDept/' + deptId,
    method: 'get'
  });
}

// 获取组织可选项树图列表
function selectAllRootDeptTree() {
  return (0, _request.default)({
    url: _cloud.urls.user + '/system/dept/selectAllRootDeptTree',
    method: 'get'
  });
}

// 查询关联的根组织的所有末级组织
function selectChildrenDeptByRootId() {
  return (0, _request.default)({
    url: _cloud.urls.user + '/system/dept/selectChildrenDeptByRootId',
    method: 'get'
  });
}

// 查询关联的根组织的所有末级组织
function listChildrenDeptByRootId(rootDeptId) {
  return (0, _request.default)({
    url: _cloud.urls.user + '/system/dept/listChildrenDeptByRootId?rootDeptId=' + rootDeptId,
    method: 'get'
  });
}

// 查询用户关联的所有部门（租户过滤）
function getUserDeptList() {
  return (0, _request.default)({
    url: _cloud.urls.user + '/system/dept/userDeptAll/deptAll',
    method: 'get'
  });
}